import { Checkbox } from '@mui/material';
import React from 'react';
import { SpotLockUser } from '../../../sp-types/userType';

interface Props {
  users: SpotLockUser[];
  setUserProp: (_userId: string, _prop: string, _val: any) => void;
}
export const UserPermissions: React.FC<Props> = ({ users, setUserProp }) => {
  return (
    <div className="flex flex-col w-full gap-1">
      <div className="flex gap-2 border-t border-gray-110 justify-between items-center font-extra-bold">
        <p className="w-24">Name</p>
        <p className="w-40">Email</p>
        <p className="w-36">accountId</p>
        <p className="w-36">isApproved</p>
        <p className="w-36">isAdmin</p>
        <p className="w-36">isEditEnabled</p>
      </div>
      {users.map((user, i) => (
        <div key={i} className="flex gap-2 border-t border-gray-110 justify-between items-center">
          <p className="w-24">{user.name}</p>
          <p className="w-40">{user.email}</p>
          <p className="w-36">{user.accountId}</p>
          <p className="w-36">
            <Checkbox
              checked={user.isApproved}
              onChange={({ target }) => setUserProp(user.id, 'isApproved', target.checked)}
            />
          </p>
          <p className="w-36">
            <Checkbox
              checked={user.isAdmin}
              onChange={({ target }) => setUserProp(user.id, 'isAdmin', target.checked)}
            />
          </p>
          <p className="w-36">
            <Checkbox
              checked={user.isEditEnabled}
              onChange={({ target }) => setUserProp(user.id, 'isEditEnabled', target.checked)}
            />
          </p>
        </div>
      ))}
    </div>
  );
};
